let timer: ReturnType<typeof setTimeout> | null = null;
let lastCallArgs: any = null;

export default function dataLayerPush(data: any) {
  if (data
    && window.dataLayer
    && typeof window.dataLayer === 'object'
    && typeof window.dataLayer.push === 'function'
  ) {
    window.dataLayer.push(data);
  } else if (data
    && typeof data === 'object'
    && typeof data.eventCallback === 'function'
  ) {
    data.eventCallback();
  }
}

export function delayedDataLayerPush(data: any) {
  lastCallArgs = data;
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    timer = null;
    dataLayerPush(lastCallArgs);
    lastCallArgs = null;
  }, 1000);
}
